import { PciI } from "interfaces/Pci";
import { useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import {
  EspaciosTable,
  EspaciosTableRow,
} from "components/EspaciosTable/EspaciosTable";

interface Props {
  elemento: PciI | null;
}

export const PCIDetailPanel = ({ elemento }: Props) => {
  const espaciosTableRows: EspaciosTableRow[] = useMemo(() => {
    if (!elemento?.cajaCurricularPci?.espaciosCurricularesPci) return [];

    return elemento.cajaCurricularPci.espaciosCurricularesPci.map(
      (esp: any) => ({
        id: esp.id,
        nombre: esp.nombre,
        anio: esp.anio ?? 0,
        horasSemanales: esp.carga_horaria,
        cuatrimestre: esp.cuatrimestre ?? null,
        area: esp.area?.nombre ?? esp.area_nombre ?? "",
        tipoEspacio: esp.tipoEspacio?.nombre ?? esp.tipo_espacio_nombre ?? "",
        detalleModificacion: esp.detalle_modificacion,
      })
    );
  }, [elemento]);

  if (!elemento) return null;

  return (
    <Col>
      <Row>
        <Col sm={6} lg={6} className="mb-4">
          <b>Nombre:</b> <br></br>
          {elemento.nombre}
        </Col>

        <Col sm={6} lg={6} className="mb-4">
          <b>Año de implementación:</b> <br></br>
          {elemento.anio_implementacion}
        </Col>

        <Col sm={6} lg={6} className="mb-4">
          <b>Plan de estudio:</b> <br></br>
          {elemento.planEstudio?.nombre}
        </Col>

        <Col sm={6} lg={6} className="mb-4">
          <b>Institución:</b> <br></br>
          {elemento.institucion?.nombre}
        </Col>

        <Col sm={6} lg={6} className="mb-4">
          <b>Estado:</b> <br></br>
          {elemento.estado?.nombre}
        </Col>

        <Col sm={12} className="mb-4">
          <b>Normativas:</b> <br></br>
          {elemento.normativas?.map((n) => n.nombre).join(" - ") || "-"}
        </Col>

        <hr></hr>

        <Col sm={12} className="mb-4">
          <h5 className="mb-3">
            Caja Curricular PCI:{" "}
            {elemento.cajaCurricularPci?.descripcion ?? "-"}{" "}
            {elemento.cajaCurricularPci?.version
              ? `(v${elemento.cajaCurricularPci.version})`
              : ""}
          </h5>
          {espaciosTableRows.length > 0 ? (
            <EspaciosTable
              espacios={espaciosTableRows}
              readonly
              maxHeight="300px"
              showDetalleModificacion
            />
          ) : (
            <p className="text-muted">
              Sin espacios curriculares configurados.
            </p>
          )}
        </Col>
      </Row>
    </Col>
  );
};
